import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import get from 'lodash/get';
import has from 'lodash/has';
import map from 'lodash/map';
import includes from 'lodash/includes';
import valuesIn from 'lodash/valuesIn';
import App from 'modules/App';
import OptionBox from 'components/Form/OptionBox';
import { useAction } from 'hooks';
import Button from 'components/Form/Button';
import messages from '../../messages';
import { SIGN_UP_FORM } from '../../constants';
const Actions = ({ onBack, onContinue })=>{
    const formValues = useSelector(App.selectors.formSelector(SIGN_UP_FORM));
    const isMobileDisplayMode = useSelector(App.selectors.isMobileDisplayMode);
    return /*#__PURE__*/ _jsxs("div", {
        className: "row flex-column-reverse flex-sm-row",
        children: [
            !isMobileDisplayMode && /*#__PURE__*/ _jsx("div", {
                className: "col-12 col-sm-6",
                children: /*#__PURE__*/ _jsx(Button, {
                    styleModifier: "primary",
                    labelMessage: App.messages.buttons.back,
                    className: "btn--block",
                    onClick: onBack
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "col-12 col-sm-6",
                children: /*#__PURE__*/ _jsx(Button, {
                    styleModifier: "primary",
                    labelMessage: App.messages.buttons.continue,
                    className: "btn--block btn--filled",
                    isDisabled: !has(formValues, 'values.scope'),
                    onClick: onContinue
                })
            })
        ]
    });
};
const renderScopeBox = (availableScopes, scopeName, formValue)=>{
    const onSetFormValue = useAction(App.actions.setFormValue, SIGN_UP_FORM);
    return /*#__PURE__*/ _jsx(OptionBox, {
        id: "scope",
        value: formValue,
        inputValue: scopeName,
        labelMessage: messages.scopes[scopeName],
        infoMessage: messages.scopeInfos[scopeName],
        isDisabled: !includes(availableScopes, scopeName),
        onChange: onSetFormValue
    }, scopeName);
};
const ChooseScope = ({ availableScopes, onBack, onContinue })=>{
    const formValues = useSelector(App.selectors.formSelector(SIGN_UP_FORM));
    const formValue = get(formValues, 'values.scope');
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                children: map(valuesIn(availableScopes), (scopeName)=>renderScopeBox(availableScopes, scopeName, formValue))
            }),
            /*#__PURE__*/ _jsx(Actions, {
                onBack: onBack,
                onContinue: onContinue
            })
        ]
    });
};
export default ChooseScope;
